module.exports = __webpack_public_path__ + "static/media/projectsImage3.b0d4b00e.jpg";